import { render } from "./NexusSetting.vue?vue&type=template&id=209dc1b5"
import script from "./NexusSetting.vue?vue&type=script&lang=js"
export * from "./NexusSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__